<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      md="12"
      xl="12"
    >
      <b-overlay
        id="overlay-background"
        :show="betalingPaymentsBusy"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-card-header
            class="base-document-header"
          >
            <b-card-title>{{ $t('DEBTIA_INVOICES') }}</b-card-title>
            <b-card-title class="text-primary">
            <!-- <drag-links
              :parent="5"
              :side="side"
              :custom-change="customChange"
            /> -->
            </b-card-title>
          </b-card-header>
          <b-table
            v-if="invoicesData.length > 0"
            ref="refUserListTable"
            class="position-relative"
            :items="invoicesData"
            responsive
            :fields="invoicesColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="No matching records found"
            :sort-desc.sync="isSortDirDesc"
            selectable
            :select-mode="selectMode"
            @row-selected="onInvoiceSelected"
          >
            <template #cell(invoice_bc_id)="data">

              <b-badge
                :variant="data.item.bc_approved ? 'light-success' : 'light-warning'"
              >
                {{ data.item.invoice_bc_id }}
              </b-badge>
            </template>
            <template
              #cell(invoice_date)="data"
            >
              {{ formattedDate(data.item.invoice_date) }}
            </template>
            <template
              #cell(due_date)="data"
            >
              {{ formattedDate(data.item.due_date) }}
            </template>
            <template
              #cell(total)="data"
            >
              {{ formatCurrency(data.item.total, defaultCurrency) }}
            </template>
            <template #cell(paid)="data">
              <b-link
                v-if="data.item.case_id"
                class="font-weight-bold d-block text-nowrap"
                :href="'/cases/details/v2/'+data.item.case_id"
                target="_blank"
              >
                <b-badge
                  :variant="data.item.paid ? 'light-success' : 'light-danger'"
                >
                  {{
                    !data.item.bc_approved ? 'Not Approved'
                    : data.item.paid ? 'Paid'
                      : data.item.case_id ? 'Case Runnig ' + data.item.case_id : 'Unpaid'
                  }}
                </b-badge>
              </b-link>
              <b-badge
                v-else
                :variant="data.item.paid ? 'light-success' : 'light-danger'"
              >
                {{
                  !data.item.bc_approved ? 'Not Approved'
                  : data.item.paid ? 'Paid'
                    : data.item.case_id ? 'Case Runnig ' + data.item.case_id : 'Unpaid'
                }}
              </b-badge>
            </template>
            <!-- Column: Company -->
            <!-- <template
          v-if="1 < 0"
          #cell(company)="{data}"
        >
          {{ data.item.company }}
        </template> -->

            <!-- Column: Role -->
            <!-- Column: Actions -->
          </b-table>
          <b-alert
            v-else
            variant="warning"
            show
          >
            <div class="alert-body">
              {{ $t('DEBTIA_NO_INVOICES_MSG') }}
            </div>
          </b-alert>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BTable, BCardHeader, BCardTitle, BBadge, BLink, BOverlay,
} from 'bootstrap-vue'
import axios from '@axios'
// import store from '@/store'
import { EventBus } from '@/event-bus'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BTable,
    BBadge,
    BLink,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BCardHeader,
    BCardTitle,
    BOverlay,
    // DragLinks,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      sortBy: 'DESC',
      isSortDirDesc: true,
      invoicesData: [],
      caseId: this.$route.params.id,
      betalingPaymentsBusy: true,
      selectMode: 'single',
      defaultCurrency: localStorage.getItem('defaultCurrency') || 'DKK',
    }
  },
  computed: {
    invoicesColumns() {
      const temp = [
        { key: 'invoice_bc_id', sortable: true, label: i18n.t('INVOICE_BC_ID') },
        { key: 'invoice_date', sortable: true, label: i18n.t('DEBTIA_INVOICE_DATE') },
        { key: 'due_date', sortable: true, label: i18n.t('DEBTIA_DUE_DATE') },
        { key: 'total', sortable: true, label: i18n.t('DEBTIA_TOTAL') },
        { key: 'paid', sortable: true, label: i18n.t('DEBTIA_STATUS') },
      ]

      if (this.role === 'super-admin') {
        temp.splice(
          1, 0, { key: 'company', sortable: false, label: this.$t('DEBTIA_COMPANY') },
        )
      }

      return temp
    },
  },
  // setup() {
  //   const { invoicesData } = store.state['case-details']
  //   return {
  //     invoicesData,
  //   }
  // },
  created() {
    EventBus.$on('refreshBetalingInvoices', () => {
      this.getInvoices()
    })
  },
  methods: {
    async fetchInitialData() {
      await this.getInvoices()
    },
    formatCurrency(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    formattedDate(date) {
      if (!date) return 'Invalid date' // Return an empty string if date is not provided
      // Convert the date to a string if it's not already one
      const dateString = String(date)
      // Check if the date string is in the correct format (YYYY-MM-DD)
      if (dateString.includes('-')) {
        const [year, month, day] = dateString.split('-')
        return `${day}-${month}-${year}`
      }
      // Handle invalid date format or other cases
      return 'Invalid date'
    },
    onInvoiceSelected(item) {
      window.open(`/cases/view-invoice/${item[0].id}`, '_blank')
    },
    async getInvoices() {
      this.betalingPaymentsBusy = true
      const url = `${constants.baseUrlV2}/debt-case/get-debt-case-invoices/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.invoicesData = response.data.data.data
          this.betalingPaymentsBusy = false
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
